// Placeholder for the inevitable time we will want a custom header
const getNewsHeaderControls = () => ({ controls: null });

export default getNewsHeaderControls;
